// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AntiTrackYellowIcon } from '../../components';

const Label = styled.h2`
  margin: 0;
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.625rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const AntitrackHeader = () => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      <AntiTrackYellowIcon />
      <Label>{t('Norton AntiTrack')}</Label>
    </HeaderContainer>
  );
};
